import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { Element } from 'domhandler';
import { styleToString } from '../utils/index.js';
var _excluded = ["type", "children"];
// Map Slate element names to HTML tag names
// Staightforward transform - no attributes are considered
// Use transforms instead for more complex operations
// left side is what slate calls it. right side is the html element
var ELEMENT_NAME_TAG_MAP = {
  link: 'a',
  span: 'span',
  div: 'div',
  paragraph: 'p',
  'heading-one': 'h1',
  'heading-two': 'h2',
  'numbered-list': 'ol',
  'bulleted-list': 'li',
  blockquote: 'blockquote',
  iframe: 'iframe'
};
var MARK_ELEMENT_TAG_MAP = {
  strikethrough: ['s'],
  underline: ['u'],
  code: ['pre', 'code']
};
var addAttributes = function addAttributes(tag, props) {
  var _props$node = props.node;
  _props$node.type;
  _props$node.children;
  var attrs = _objectWithoutProperties(_props$node, _excluded);
  return new Element(tag, _objectSpread2({}, attrs), props.children);
};
var markAttributes = function markAttributes(node) {
  return _objectSpread2(_objectSpread2({}, node["class"] && {
    "class": node["class"]
  }), node.style && {
    style: node.style
  });
};
var slateToHtmlConfig = {
  markMap: MARK_ELEMENT_TAG_MAP,
  elementMap: ELEMENT_NAME_TAG_MAP,
  elementAttributeTransform: function elementAttributeTransform(_ref) {
    var node = _ref.node;
    if (node.align) {
      return {
        style: styleToString({
          'text-align': node.align
        })
      };
    }
  },
  markTransforms: {
    // marks to transform. Should not be also found in MARK_ELEMENT_TAG_MAP or duplicates will appear when editing in text editor
    // a mark is not an element
    bold: function bold(_ref2) {
      var node = _ref2.node;
      return new Element('strong', markAttributes(node));
    },
    italic: function italic(_ref3) {
      var node = _ref3.node;
      return new Element('i', markAttributes(node));
    }
  },
  elementTransforms: {
    quote: function quote(_ref4) {
      var _ref4$children = _ref4.children,
        children = _ref4$children === void 0 ? [] : _ref4$children;
      var p = [new Element('p', {}, children)];
      return new Element('blockquote', {}, p);
    },
    image: function image(props) {
      return addAttributes('img', props);
    },
    'heading-one': function headingOne(props) {
      return addAttributes('h1', props);
    },
    'heading-two': function headingTwo(props) {
      return addAttributes('h2', props);
    },
    p: function p(props) {
      return addAttributes('p', props);
    },
    div: function div(props) {
      return addAttributes('div', props);
    },
    span: function span(props) {
      return addAttributes('span', props);
    },
    iframe: function iframe(props) {
      return addAttributes('iframe', props);
    },
    link: function link(_ref5) {
      var node = _ref5.node,
        _ref5$children = _ref5.children,
        children = _ref5$children === void 0 ? [] : _ref5$children;
      return new Element('a', _objectSpread2(_objectSpread2(_objectSpread2({
        href: node.url,
        target: '_blank'
      }, node["class"] && {
        "class": node["class"]
      }), node.style && {
        style: node.style
      }), node.title && {
        title: node.title
      }), children);
    }
  },
  encodeEntities: false,
  alwaysEncodeBreakingEntities: true,
  alwaysEncodeCodeEntities: false
};
export { slateToHtmlConfig };